import { createBrowserRouter, Navigate, RouterProvider } from 'react-router';
import { AdminRoleRoute } from './AdminRoleRoute';
import { ProtectedRoute } from './ProtectedRoute';
import { RouteErrorBoundary } from './RouteErrorBoundary';
import { StaffShell } from '@/components/layout/StaffShell';
import { LoginPage } from '@/pages/LoginPage';
import { CustomersPage } from '@/features/customers/pages/CustomersPage';
import { CustomerShell } from '@/features/customers/pages/CustomerShell';
import { CustomerDevicesPage } from '@/features/customers/pages/CustomerDevicesPage';
import { CustomerFleetsPage } from '@/features/customers/pages/CustomerFleetsPage';
import { EmployeePeersPage } from '@/features/network/pages/EmployeePeersPage';
import { SubnetsPage } from '@/features/network/pages/SubnetsPage';
import { AdminUsersPage } from '@/features/admin-users/pages/AdminUsersPage';
import { EnrollLaptopPage } from '@/features/enroll/pages/EnrollLaptopPage';

const router = createBrowserRouter([
  {
    path: '/',
    errorElement: <RouteErrorBoundary />,
    children: [
      // Root → /staff
      { index: true, element: <Navigate to="/staff/customers" replace /> },

      // Public: login page
      { path: 'staff/login', element: <LoginPage /> },

      // Authenticated: needs Firebase token + staffMe approval
      {
        element: <ProtectedRoute />,
        children: [
          {
            path: 'staff',
            element: <AdminRoleRoute />,
            children: [
              {
                element: <StaffShell />,
                children: [
                  // /staff → /staff/customers
                  { index: true, element: <Navigate to="/staff/customers" replace /> },

                  // Customers
                  { path: 'customers', element: <CustomersPage /> },
                  {
                    path: 'customers/:accountId',
                    element: <CustomerShell />,
                    children: [
                      {
                        index: true,
                        element: <Navigate to="devices" replace />,
                      },
                      { path: 'devices', element: <CustomerDevicesPage /> },
                      { path: 'fleets', element: <CustomerFleetsPage /> },
                    ],
                  },

                  // Network
                  {
                    path: 'network',
                    children: [
                      {
                        index: true,
                        element: <Navigate to="peers" replace />,
                      },
                      { path: 'peers', element: <EmployeePeersPage /> },
                      { path: 'subnets', element: <SubnetsPage /> },
                    ],
                  },

                  // My Account (agent enrollment, future account-level self-service)
                  { path: 'enroll', element: <EnrollLaptopPage /> },

                  // Admin Users (root-only — upstream guard + defensive check)
                  {
                    path: 'admin-users',
                    element: <AdminRoleRoute requiredRole="root" />,
                    children: [{ index: true, element: <AdminUsersPage /> }],
                  },
                ],
              },
            ],
          },
        ],
      },

      // Fallback
      { path: '*', element: <Navigate to="/staff/customers" replace /> },
    ],
  },
]);

export function AppRouter() {
  return <RouterProvider router={router} />;
}
